import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DpsService } from './dps-service.service';
import { AuthService } from '../../../../auth/auth.service';
import { JobConstants } from '../../../../../common/utils/job-constants';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
  selector: 'dashboard-dps',
  styles: [require('./dps-dashboard.scss')],
  template: require('./dps-dashboard.component.html')
})

export class DPSDashboard {
    public vdcPolicyEnabledPieChartData: any;
    public vdcPolicyEnabledPieChartOptions: any;
    public vAppProtectedPieChartData: any;
    public vAppProtectedPieChartOptions: any;
    public storageConsumedPieChartData: any;
    public storageConsumedPieChartOptions: any;
    private isDpsDeletedVappsPopupVisible: boolean = false;
    private activityLogService = JobConstants.SERVICES['VcdDpsJob'];
    viewLineChart: boolean;
    tempSortedList: any;
    sortedList = [];
    vdcList: any;
    vdcCount = 0;
    deletedVappsCount = 0;
    totalStorageConsumedDeletedVapp = 0;
    deletedvApps: any;
    vdcsProtected = 0;
    totalStorageConsumed = 0.0;
    allvApps = {'total': 0, 'protected': 0};
    tabTitles = ["Dashboard" , "Activity Logs", "Replicated Virtual Datacenters"]; // todo translation
    private loaded: boolean = false;
    private isActivityLogVisible: boolean = false;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private isComponentLoaded: boolean = false;
    private currentTabId: number = 0;
    private hasReplicationEnabled: boolean = false;
    private isDpsHealthy: boolean = false;
    constructor(private service: DpsService, 
                public authService: AuthService,
                private router: Router,
                private rss: RefreshSharedService) {
        this.viewLineChart = false;
        this.authService.getDpsHealthChangeEvent().subscribe(data => {
            this.loaded = true;
            this.isDpsHealthy = ( data && data.isHealthy ) ? true : false;
            if ( this.isDpsHealthy ) {
                this.getAllVDCsList();
                this.getDeletedAllVApps();
            }
        });
        this.rsService = rss;
        this.currentClassName = 'DPSDashboard';  
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });
        this.rsService.setParam({
            'loadedComponent': this.currentClassName, 
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        this.loaded = ( this.authService ) ? true : false;
        this.isDpsHealthy = ( this.loaded && this.authService.DPS_HEALTH && this.authService.DPS_HEALTH.isHealthy ) ? true : false;
        if ( this.isDpsHealthy ) {
            this.getAllVDCsList();
            this.getDeletedAllVApps();
        }
    }

   handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {    
            if ( this.isDpsHealthy ) { 
                this.getAllVDCsList();
                this.getDeletedAllVApps();  
            }      
        }
  }

    private getDeletedAllVApps() {
        this.isComponentLoaded = false;
        this.service.getDeletedAllVApps().subscribe(
        data => {
            this.isComponentLoaded = true;
            this.deletedvApps = data;
            if(this.deletedvApps) {
                this.deletedVappsCount = this.deletedvApps.length;
                for (let k = 0; k < this.deletedvApps.length; k += 1) {
                    if (this.deletedvApps[k]['statistics'] && this.deletedvApps[k]['statistics']['storageConsumed']) {
                        this.totalStorageConsumedDeletedVapp += this.deletedvApps[k]['statistics']['storageConsumed'];
                    }
                }
                this.totalStorageConsumedDeletedVapp = Math.round(this.totalStorageConsumedDeletedVapp / 1024);
            }
        },
        error => { window.alert(error); });
    }


    private getAllVDCsList() {
        this.isComponentLoaded = false;
        this.service.getAllVDCsList().subscribe(
         data => {
             this.isComponentLoaded = true;
             this.vdcList = data;
             if(this.vdcList) {
                 this.vdcCount = this.vdcList.length;
                 for (let i = 0; i < this.vdcList.length; i += 1) {
                     if (this.vdcList[i].schedule && this.vdcList[i].schedule.scheduleType) {
                         this.vdcsProtected += 1;
                     }
                     if (this.vdcList[i].statistics) {
                         if (this.vdcList[i].statistics.totalVAppCount) {
                             this.allvApps.total += this.vdcList[i].statistics.totalVAppCount;
                         }
                         if (this.vdcList[i].statistics.protectedVAppCount) {
                             this.allvApps.protected += this.vdcList[i].statistics.protectedVAppCount;
                         }
                         if (this.vdcList[i].statistics.storageConsumed) {
                             this.totalStorageConsumed += this.vdcList[i].statistics.storageConsumed;
                         }
                     }
                 }
                 let total:number = this.totalStorageConsumed;
                 // VDC have Policy Enabled Pie Chart Data & Options
                 this.vdcPolicyEnabledPieChartData = {
                     labels: ['Policy Activated', 'Policy Deactivated'],
                     datasets: [
                         {
                             data: [this.vdcsProtected, this.vdcList.length - this.vdcsProtected],
                             backgroundColor: ['#007CBB']
                         }
                     ]
                 };
                 this.vdcPolicyEnabledPieChartOptions = {
                     scaleShowVerticalLines: false,
                     responsive: true,
                     legend: {
                         display: false,
                         position: 'top'
                     },
                     cutoutPercentage: 75
                 };
                 // vApps Protedted Pie Chart Data & Options
                 this.vAppProtectedPieChartData = {
                     labels: ['vApps Protected', 'vApps Not Protected'],
                     datasets: [
                         {
                             data: [this.allvApps.protected, this.allvApps.total - this.allvApps.protected],
                             backgroundColor: ['#007CBB']
                         }
                     ]
                 };
                 this.vAppProtectedPieChartOptions = {
                     scaleShowVerticalLines: false,
                     responsive: true,
                     legend: {
                         display: false,
                         position: 'top'
                     },
                     cutoutPercentage: 75
                 };
                 // vApps Protedted Pie Chart Data & Options
                 this.storageConsumedPieChartData = {
                     labels: ['Storage Consumed (TB)', 'Storage Free'],
                     datasets: [
                         {
                             data: [Number(this.totalStorageConsumed).toFixed(2), 0],
                             backgroundColor: ['#E6E6E6']
                         }
                     ]
                 };
                 this.storageConsumedPieChartOptions = {
                     scaleShowVerticalLines: false,
                     responsive: true,
                     legend: {
                         display: false,
                         position: 'top'
                     },
                     cutoutPercentage: 75
                 };
                 // Data for Top Bar Chart
                 this.tempSortedList = this.vdcList.map(function (s) {
                     return {
                         'id': s.id,
                         'orgId': s.orgId ? s.orgId : null,
                         'label': s.name,
                         'value': s.statistics.storageConsumed,
                         'renderedLabel': s.name.substring(0, 25),
                         'renderedValue': Number(s.statistics.storageConsumed).toFixed(2)
                     };
                 });
                 this.tempSortedList = this.tempSortedList.sort(function (a, b) {
                     return parseFloat(b.value) - parseFloat(a.value);
                 });
                 if (this.tempSortedList.length >= 5) {
                     for (let i = 0; i < 5; i += 1) {
                         this.sortedList.push(this.tempSortedList[i]);
                     }
                     for (let j = 0; j < 5; j += 1) {
                         this.sortedList[j]['percent'] = total ? Math.round((this.sortedList[j].value / total) * 100) : 0;
                         this.sortedList[j]['tooltipString'] = this.sortedList[j].renderedValue + ' MB (' + Math.round(this.sortedList[j]['percent']) + '%)';
                     }
                 }
                 else {
                     for (let i = 0; i < this.tempSortedList.length; i += 1) {
                         this.sortedList.push(this.tempSortedList[i]);
                     }
                     for (let j = 0; j < this.tempSortedList.length; j += 1) {
                         this.sortedList[j]['percent'] = total ? Math.round((this.sortedList[j].value / total) * 100) : 0;
                         this.sortedList[j]['tooltipString'] = this.sortedList[j].renderedValue + ' MB (' + Math.round(this.sortedList[j]['percent']) + '%)';
                     }
                 }
             }
          },
          error => { window.alert(error); }
        );
    }


    viewStorageConsumedLineChart() {
        this.viewLineChart = true;
    }

    viewAllDeletedVapps() {
        this.isDpsDeletedVappsPopupVisible = true;
    }

    goToVdc(vdc: any) {
        if (vdc && vdc.id && vdc.orgId) {
            this.router.navigate(['inventory/org/' + vdc.orgId + '/vdc/' + vdc.id]);
        }
    }

    onTabIndexChanged(event) {
        if (event === 0) {
            this.rsService.setParam({
                'loadedComponent': this.currentClassName, 
                'detailPageIDName': '',
                'shouldReloadInventoryTree': false
            });
        }
        this.currentTabId = event;
        this.isActivityLogVisible = (event === 1) ? true : false;
  }
   ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/dashboard/dps-dashboard.component.ts